import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { FaPenToSquare, FaCheck, FaX } from "react-icons/fa6";
import { API_ciudadanos } from "../../config/apiConfig";
import { useAuth } from "../../context/AuthContext";

 const colectivosDisponibles = [
    "Jóvenes 18-29",
    "Mayores de 45",
    "Larga duración",
    "Discapacitados",
    "Mujeres",
    "ERACIS",
    "Inmigrantes"
  ];

const Colectivos = ({ usuario }) => {
  const { token } = useAuth();

  const [colectivosSeleccionados, setColectivosSeleccionados] = useState([]);
  const [editando, setEditando] = useState(false);

  // Normaliza texto para comparar sin tildes y en minúsculas
  const normalizar = (texto) =>
    texto
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();

  useEffect(() => {
    if (
      usuario?.colectivosSociales &&
      Array.isArray(usuario.colectivosSociales)
    ) {
      const colectivosNormalizados = usuario.colectivosSociales.map(normalizar);

      const colectivosIniciales = colectivosDisponibles.filter((colectivo) =>
        colectivosNormalizados.includes(normalizar(colectivo))
      );

      setColectivosSeleccionados(colectivosIniciales);
    }
  }, [usuario]);

  const handleCheckboxChange = (colectivo) => {
    setColectivosSeleccionados((prev) =>
      prev.includes(colectivo)
        ? prev.filter((item) => item !== colectivo)
        : [...prev, colectivo]
    );
  };

  const handleGuardar = async () => {
    const body = { colectivosSociales: colectivosSeleccionados };

    try {
      const res = await fetch(`${API_ciudadanos}/${usuario.userId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": token,
        },
        body: JSON.stringify(body),
      });

      if (!res.ok) throw new Error("Error al actualizar colectivos");

      toast.success("Colectivos actualizados correctamente");
      setEditando(false);
    } catch (error) {
      console.error("Error al actualizar colectivos:", error);
      toast.error("Error al guardar los colectivos");
    }
  };

  const handleCancelar = () => {
    setEditando(false);
    // Vuelve al valor original del usuario
    if (usuario?.colectivosSociales) {
      setColectivosSeleccionados(usuario.colectivosSociales);
    }
  };

  return (
    <div className="colectivos caja-verde">
      <div className="titulo-editar between fondo-verde">
        <h2 className="blanco fondo-verde mayusculas">Colectivos</h2>
        {!editando && (
          <button
            className="fondo-verde blanco no-border"
            aria-label="Editar colectivo"
            onClick={() => setEditando(true)}
          >
            <FaPenToSquare />
          </button>
        )}
      </div>

      <div className="contenido wrap">
        {colectivosDisponibles.map((colectivo) => (
          <label key={colectivo} className="align-center gap-5 w-50p">
            <input
              type="checkbox"
              checked={colectivosSeleccionados.includes(colectivo)}
              onChange={() => handleCheckboxChange(colectivo)}
              disabled={!editando}
              style={{
                accentColor: "#28a745",
                cursor: editando ? "pointer" : "default",
              }}
            />
            {colectivo}
          </label>
        ))}
      </div>

      {/* Botones Guardar o cancelar edición */}
      {editando && (
        <div className="check flex end gap-10 mr-20 mb-5">
          <button
            aria-label="Guardar cambios"
            className="fondo-blanco verde"
            onClick={handleGuardar}
          >
            <FaCheck />
          </button>
          <button
            aria-label="Cancelar cambios"
            className="fondo-blanco rojo"
            onClick={handleCancelar}
          >
            <FaX />
          </button>
        </div>
      )}
    </div>
  );
};

export default Colectivos;
